<template>
  <div class="card">
    <div class="card__image">
      <img v-if="image" class="card__img" :src="image" :alt="imageAlt" />
      <div class="card__info" v-else>
        <slot name="card-info"></slot>
      </div>
    </div>

    <div class="card__details">
      <span class="card__description">
        <slot name="card-description"></slot>
      </span>
      <span class="card__distance">
        <slot name="card-distance"></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardImage',
  props: {
    image: {
      type: String,
    },
    imageAlt: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  position: relative;
  width: 400px;

  transition: transform 0.3s ease-out;

  &__image {
    height: 320px;
  }

  &__img {
    border-radius: 8px;
    z-index: 0;

    box-shadow: 6px 6px 8px -4px hsl(var(--clr-primary-500));
  }

  &__info {
    width: 400px;
    height: 266px;
    line-height: 24px;
    font-size: 16px;
    color: hsl(var(--clr-primary-100));
    color: hsl(var(--clr-primary-500));
    background-color: hsl(var(--clr-primary-100));
    background-color: rgba(255, 255, 255, 0.75);

    border: 1px solid hsl(var(--clr-primary-500));
    border-radius: 8px;
    padding: 8px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  &__details {
    position: relative;
    z-index: 3;

    display: flex;
    flex-direction: column;

    border: 1px solid #2878c236;
    border-bottom: hsl(var(--clr-primary-700));
    border-radius: 5px;

    margin: 0 auto;
    width: 80%;
    background-color: hsl(var(--clr-primary-100));
    margin-top: -70px;
    padding: 12px;

    box-shadow: 6px 6px 8px -4px hsl(var(--clr-primary-500));
  }

  &__description {
    color: hsl(var(--clr-primary-500));
    font-size: 16px;
    font-family: var(--ff-roboto-sans);
    font-weight: bold;
    margin-bottom: 5px;

    text-align: start;
  }

  &__distance {
    color: hsl(var(--clr-primary-700));
    font-size: 12px;
    align-self: flex-end;
  }
}
@media (max-width: 900px) {
  .card {
    width: 250px;

    &__image {
      height: 16px;
    }

    &__info {
      width: 250px;
      height: 170px;
      overflow: scroll;
      font-size: 12px;
      line-height: 14px;
    }

    &__details {
      margin-top: -20px;
    }
  }
}
</style>
